const e = (t) => ({
  currentTarget: { value: t },
  target: { value: t }
});
export {
  e as getValueAsEvent
};
